import React,{useState,useEffect} from "react";
import { makeStyles } from 'tss-react/mui';
import { TextField, Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import { setError } from "../store/features/error/errorSlice";
import { connect } from "react-redux";
import { sendEmail } from "../utils/utils";
import AdminDialog from "./adminDialog";

const mapDispatchToProps = {
  setError,
};

// The address the server sends these messages from.
const FROM_ADDRESS = "no-reply@my-cloudline.com";

const useStyles = makeStyles()((theme) => ({
  field: {
    "& .MuiInputBase-input::placeholder": {
      fontSize: "0.85em",
      color: theme.palette.text.disabled,
      opacity: 1,
    },
  },
  note: {
    marginRight: "auto",
    fontSize: 12,
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  textButton: {
    textTransform: "none",
    color: theme.palette.text.secondary,
  },
  primary: {
    textTransform: "none",
    minWidth: 112,
    color: "#fff",
    backgroundColor: theme.palette.primary.light,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      filter: "brightness(0.93)",
      boxShadow: "none",
    },
  },
}));

const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());

const ContactEmail = (props) => {
    const { classes } = useStyles();
    const {
      open,
      setOpen,
      setError,
      to,
    } = props;
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [sending, setSending] = useState(false);

    // Every message starts empty.
    useEffect(() => {
      if (open) {
        setSubject('');
        setBody('');
        setSending(false);
      }
    }, [open, to]);

    const recipientValid = isEmailValid(to);
    const canSend = recipientValid && body.trim() !== "" && !sending;

    const handleSubmit = async () => {
      if (!canSend) return;
      setSending(true);
      let sanitizedBody = body.replace(/(?:\r\n|\r|\n)/g, '<br>');

      let data = {
        to: to,
        from: FROM_ADDRESS,
        subject: subject,
        body: sanitizedBody,
      };

      try {
        let email = await sendEmail(data);

        if(email instanceof Error) throw email.message;

        setError({
          visible: true,
          type: "success",
          message: "Email Sent Successfully.",
        });
        setOpen(false);
      } catch (error) {
        setSending(false);
        setError({
          visible: true,
          type: "error",
          message: error,
        });
      }
    };

    if (!open) return null;

    return (
      <AdminDialog
        open={open}
        onClose={() => setOpen(false)}
        icon={<EmailIcon />}
        title="Send email"
        subtitle={recipientValid ? `To ${String(to).trim()}` : "This contact has no valid email address."}
        maxWidth={520}
        footer={
          <>
            <span className={classes.note}>Sent from {FROM_ADDRESS}</span>
            <Button onClick={() => setOpen(false)} className={classes.textButton}>
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={!canSend}
              className={classes.primary}
              onClick={handleSubmit}
            >
              {sending ? "Sending…" : "Send"}
            </Button>
          </>
        }
      >
        <TextField
          id="subject"
          label="Subject"
          placeholder="What is this about?"
          value={subject}
          onChange={(event) => setSubject(event.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          autoFocus
          className={classes.field}
          slotProps={{
            inputLabel: { shrink: true },
          }}
        />
        <TextField
          id="message"
          label="Message"
          required
          multiline
          rows={7}
          value={body}
          onChange={(event) => setBody(event.target.value)}
          variant="outlined"
          fullWidth
          placeholder="Write your message"
          className={classes.field}
          slotProps={{
            inputLabel: { shrink: true },
          }}
        />
      </AdminDialog>
    );
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactEmail);
